// initial state
const state = {
    userinfo : ''
}

// getters
const getters = {
}

// actions
const actions = {

}

// mutations
const mutations = {
  saveinfo(state, info) {
    state.userinfo = info
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js